import {Component, Input, OnInit} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'longmoon-starry-night',
  templateUrl: './starry-night.component.html',
  styleUrls: ['./starry-night.component.scss'],
  animations: [
    trigger('openClose', [
      state('closed', style({
        height: '270px',
        borderWidth: '2px',
        borderColor: '#66a',
        borderStyle: 'solid',
      })),
      state('open', style({
        height: '0',
        borderWidth: 0,
      })),
      transition('open => closed', [
        animate('0.33s')
      ]),
      transition('closed => open', [
        animate('0.33s')
      ]),
    ]),
  ],
})

export class StarryNightComponent implements OnInit {

  @Input() starryNightOpen: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

  toggleStarryNight(): void {
    this.starryNightOpen = !this.starryNightOpen;
  }

}
